module.exports = __webpack_public_path__ + "static/media/user-add.b4399a00.svg";